<template>
  <div class="switch-wrapper" :class="disabled ? 'disabled' : ''">
    <label class="switch" :style="{ width: width + 'px' }">
      <input type="checkbox" v-model="model" id="switch-input" :disabled="disabled" />
      <span class="slider round"></span>
    </label>
    <label class="text" for="switch-input">{{ text }}</label>
  </div>
</template>

<script setup lang="ts">
interface Props {
  value?: boolean;
  width?: string;
  text?: string;
  disabled?: boolean;
}

const model = defineModel<boolean>();

withDefaults(defineProps<Props>(), {
  value: false,
  width: "50",
  text: "",
  disabled: false,
});
</script>

<style lang="scss" scoped>
.switch-wrapper {
  display: flex;
  align-items: center;
  gap: 10px;

  &.disabled {
    opacity: 0.6;
    pointer-events: none;
  }
}

.switch {
  position: relative;
  display: inline-block;
  min-width: 50px;
  height: 24px;
}

.switch input {
  visibility: hidden;
  position: absolute;
  left: -9999;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0px;
  left: 0px;
  right: 0;
  bottom: 0;
  background-color: #dfe3e4;
  -webkit-transition: 0.4s;
  transition: 0.4s;
  border-radius: 32px;
}

.slider:before {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
  border-radius: 50%;
}

input:checked + .slider {
  background-color: #8fc841;
}

input:focus + .slider {
  box-shadow: 0 0 1px #8fc841;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
  left: auto;
  right: 29px;
}
.text {
  cursor: pointer;
}
</style>
